import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { IdentityConfirmationOption } from '../../../generated/graphql';

/**
 * Hook que redirige automáticamente cuando los intentos de validación se agotan.
 *
 * @param option - Opción de confirmación de identidad con información de intentos
 * @param parentUrl - URL a la que redirigir cuando se agoten los intentos
 * @param onExhausted - Callback opcional que se ejecuta antes de redirigir (ej: mostrar snackbar)
 */
export const useAttemptsExhaustedRedirect = (
  option: IdentityConfirmationOption | undefined,
  parentUrl: string,
  onExhausted?: ((show: boolean) => void) | (() => void),
) => {
  const history = useHistory();

  React.useEffect(() => {
    if (option?.attemptsExhausted) {
      if (onExhausted) {
        // Intentar llamar con parámetro, si no acepta parámetros TypeScript lo manejará
        (onExhausted as any)(true);
      }
      history.push(parentUrl);
    }
  }, [ option?.attemptsExhausted, history, parentUrl, onExhausted ]);
};
